import { OctIconButton } from "@oceantech/oceantech-ui";
import clsx from "clsx";
import { MouseEvent } from "react";
import { TableCustomCell } from "../../component/table/components/TableCustomCell";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import { CustomColumn } from "../../component/table/table-custom/tableCustomeModel";
import { formatDateTime } from "../../utils/FormatUtils";

export const MEDICAL_RECORD_COLUMNS: CustomColumn<any>[] = [
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-50px" title="Thao tác" />
		),
		accessor: "action",
		Cell: ({ row: { original }, tableOptions: { onActionButtonClick } }: any) => {
			return (
				<TableCustomCell
					className="min-w-50px"
					data={
						<div className="d-flex justify-content-center">
							<OctIconButton
								variant="edit"
								title="Xem thông tin bệnh nhân"
								onClick={(e: MouseEvent<HTMLButtonElement>) => {
									e.stopPropagation();
									onActionButtonClick(original, "viewPatient");
								}}
							>
								<i className="bi bi-eye text-navy"></i>
							</OctIconButton>
							<OctIconButton
								variant="edit"
								title="Mở hồ sơ bệnh án"
								onClick={(e: MouseEvent<HTMLButtonElement>) => {
									e.stopPropagation();
									onActionButtonClick(original, "viewMedicalRecord");
								}}
							>
								<i className="bi bi-clipboard2-pulse text-navy"></i>
							</OctIconButton>
						</div>
					}
				/>
			);
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-40px" title="STT" />
		),
		accessor: "order",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-40px text-center" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-100px" title="Mã hồ sơ" />
		),
		accessor: "medicalRecordCode",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-100px text-center" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-100px"
				title="Loại bệnh án"
			/>
		),
		accessor: "recordTypeName",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-100px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-70px" title="Số chữ ký" />
		),
		accessor: "numberOfSign",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-70px text-center" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-100px"
				title="Trạng thái hồ sơ"
			/>
		),
		accessor: "statusName",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-100px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-100px"
				title="Mã bệnh nhân"
			/>
		),
		accessor: "patientCode",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="text-center min-w-100px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-150px" title="Họ và tên" />
		),
		accessor: "fullName",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-150px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-125px"
				title="Trạng thái BN"
			/>
		),
		accessor: "visitStatusName",
		Cell: ({ row: { original } }) => {
			return <TableCustomCell data={original?.visitStatusName} className="min-w-125px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-100px" title="Ghi chú" />
		),
		accessor: "note",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="text-center min-w-100px" />;
		},
	},
];

export const MEDICAL_RECORD_SELECT_COLUMNS: CustomColumn<any>[] = [
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-50px" title="Thao tác" />
		),
		accessor: "action",
		Cell: ({ row: { original }, tableOptions: { onActionButtonClick } }: any) => {
			return (
				<TableCustomCell
					className="min-w-50px"
					data={
						<div className="d-flex justify-content-center align-items-center">
							{original?.selected ? (
								<i className="bi bi-check-circle text-success fs-2"></i>
							) : (
								<OctIconButton
									variant="edit"
									title="Xem thông tin bệnh nhân"
									onClick={(e: MouseEvent<HTMLButtonElement>) => {
										e.stopPropagation();
										onActionButtonClick?.(original, "viewPatient");
									}}
								>
									<i className="bi bi-eye text-navy"></i>
								</OctIconButton>
							)}
						</div>
					}
				/>
			);
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-50px" title="STT" />
		),
		accessor: "order",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-50px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-100px"
				title="Mã điều trị"
			/>
		),
		accessor: "code",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-100px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-200px"
				title="Khoa vào viện"
			/>
		),
		accessor: "department",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-200px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-125px"
				title="Ngày vào khám"
			/>
		),
		accessor: "date",
		Cell: ({ value }) => {
			return <TableCustomCell data={formatDateTime(value)} className="min-w-125px" />;
		},
	},
];

export const FILE_TEMPLATE_COLUMNS: CustomColumn<any>[] = [
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-80px" title="Thao tác" />
		),
		accessor: "action",
		Cell: ({ row: { original }, tableOptions: { onSelectChange } }: any) => {
			return (
				<TableCustomCell
					className="min-w-80px"
					data={
						<div className="d-flex justify-content-center align-items-center">
							<button
								className={clsx("btn btn-sm spaces px-10 py-5", {
									"btn-light-danger btn-active-color-danger": original.checked,
									"btn-light-primary btn-active-color-primary": !original.checked,
								})}
								onClick={(e: MouseEvent) => {
									e.stopPropagation();
									onSelectChange?.(original);
								}}
							>
								{original.checked ? "Bỏ chọn" : "Chọn"}
							</button>
						</div>
					}
				/>
			);
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-40px" title="STT" />
		),
		accessor: "order",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="text-center min-w-40px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader tableProps={props} className="text-center min-w-200px" title="Loại gáy" />
		),
		accessor: "type",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-200px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-100px"
				title="Mã mẫu phiếu"
			/>
		),
		accessor: "code",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-100px" />;
		},
	},
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				className="text-center min-w-200px"
				title="Tên mẫu phiếu"
			/>
		),
		accessor: "name",
		Cell: ({ value }) => {
			return <TableCustomCell data={value} className="min-w-200px" />;
		},
	},
];
